import { Box, VStack } from '@chakra-ui/react'

import { useMFNav } from './MFNav.Provider'
import MFNavNavItem from './MFNav.SidebarNavItem'

/**
 * MFNavSidebarNavBody component renders the navigation items within the sidebar.
 *
 * @returns {JSX.Element} The rendered navigation sidebar component.
 */
export default function MFNavSidebarBody() {
  const {
    // skin,
    // current: { admin, agency },
    navItems
  } = useMFNav()

  // const navItems = useMemo(() => {
  //   const permissions = admin?.admin_permissions

  //   if (permissions || permissions === false) return navWithPermissions(permissions, admin, skin.value, agency).items
  //   return []
  // }, [admin, agency, skin.value])

  return (
    <Box
      position="relative"
      w="full"
      h="full"
      overflowX="hidden"
      overflowY="auto"
      p="3"
      pb="20"
      sx={{
        '--webkit-scrollbar': '0.5rem',
        '--scrollbar-track': 'transparent',
        '--scrollbar-thumb': '#CBC9FE',
        '--scrollbar-thumb-radius': '999px',
        scrollbarWidth: 'thin',
        scrollbarColor: '#CBC9FE transparent',
        _dark: {
          '--scrollbar-thumb': '#7B67F9',
          scrollbarColor: '#7B67F9 transparent'
        }
      }}
    >
      <VStack spacing="0" mt="3">
        {navItems.map((item, i) => (
          <MFNavNavItem key={i} {...item} link={{ type: 'internal', url: item.navLink }} />
        ))}
      </VStack>
    </Box>
  )
}
